import { publicActions } from 'viem';
import {} from '../createConfig.js';
import {} from '../types/properties.js';
import {} from '../types/utils.js';
import { getClient } from './getClient.js';
export function getPublicClient(config, parameters = {}) {
    const client = getClient(config, parameters);
    return client?.extend(publicActions);
}
//# sourceMappingURL=getPublicClient.js.map